import React from 'react';
import './style.scss';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import clsx from 'clsx';

const TabsDropdown = ({ tabNames, activeTabName, onTabClick, className }) => {
  const defaultOption = {
    value: activeTabName.id,
    label: activeTabName.name,
  };

  const handleSelect = (e) => {
    onTabClick({
      id: e.value,
      name: e.label,
    });
  };

  const options = [];
  tabNames.map((item) => {
    options.push({
      value: item.id,
      label: item.name,
    });
  });

  return (
    <Dropdown
      options={options}
      onChange={(e) => handleSelect(e)}
      value={defaultOption}
      placeholder="Select an option"
      className={clsx('tabs-dropdown', className)}
      controlClassName="tabs-dropdown-label-wrapper"
      placeholderClassName="tabs-dropdown-label"
      arrowOpen={<div className="tabs-dropdown-arrow rotated" />}
      arrowClosed={<div className="tabs-dropdown-arrow " />}
      menuClassName="tabs-dropdown-items-wrapper"
    />
  );
};

export default TabsDropdown;
